import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAddUserMutation } from "@/services/user.service";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information, { UserFieldForm } from "./_information";
import { isFetchBaseQueryError } from "@/services/helpers";

export default function AddUser() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [addUser, {isSuccess, error}] = useAddUserMutation()
    const {register, handleSubmit, formState: {errors}, watch, control} = useForm<UserFieldForm>()

    const onSubmit = handleSubmit(async (data) => {
        addUser(data)
    })

    useEffect(() => {
        if(isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-sm rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("user.add_user")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    {
                        isFetchBaseQueryError(error) && <p className="mb-2 text-rose-600">{error.data.message}</p>
                    }
                    <Information register={register} control={control} errors={errors} watch={watch} />
                    
                    <div className="flex justify-end">
                        <div className="px-6">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div>
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
